import React from "react";
import { officeHours } from "../../views/customer/customerEnquiry/utils";

import "./contactCard.scss";

export default class ContactCard extends React.Component {
  public render() {

    return (
      <div className="required-details-contact">
        <h2>Need a hand?</h2>
        {/* tslint:disable-next-line: max-line-length */}
        <p>If you have any questions, or want to change which travellers are on this booking, please call us on <a href="tel:+441173257898">+44 (0)117 325 7898</a>. We're available {officeHours}.</p>
        <p>Or you can email us at <a href="mailto:team@travellocal.com">team@travellocal.com</a>.</p>
      </div>
    );
  }
}
